import React, { Component } from 'react';
import { Grid, Switch, FormControl, Select, MenuItem } from '@material-ui/core';


class AppSettingsCostAlerting extends Component {

  costAlert = () => {
    const settings = this.props.settings;
    const alertsDisabled = !settings.enabled || !settings.alert.enabled;

    // 300h = 1h meeting, for 25 people, 12 times => costing about ~15k / quarter
    const tresholds = [0,1,2,3,4,5,6,7,8,9,10,12,14,16,18,20,25,30,35,40,45,50,55,60,70,80,90,100,110,120,130,140,150,160,170,180,190,200,220,240,260,280,300] // hour tresholds
    const costAlertToggle = <Switch disabled={!settings.enabled} checked={settings.alert.enabled} onChange={ this.props.handleChange} color="primary" name="settings.alert.enabled" />
    
    return (
      <Grid item xs={12} className="mt-5 mb-5">
        { this.props.createHeader("Cost Alerting Enabled:", "These settings control if and how the cost alerting is shown on the calendar, and if configured, on the meeting validation dialog.", costAlertToggle) }
        <Grid container spacing={1} className="ml-3">
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Alert Type", "You can choose to show the alert based on individual event, or based on recurring event time estimate if available.")}
              <Grid item>
                <FormControl>
                  <Select value={settings.alert.type} disabled={alertsDisabled} onChange={ this.props.updateValue} displayEmpty name="settings.alert.type" variant="outlined" autoWidth={true}>
                    <MenuItem value="" disabled>Select to apply alert to single event, or recurring event time estimate.</MenuItem>
                    {["event", "recurring"].map(i => <MenuItem value={i} key={"alert-type-" + i}>{i}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Meeting Time Padding", "This setting adds selected amount of minutes to every meeting participation. I.e. 10 minute setting would calculate 50 minute meeting as costing 60 minutes times the number of participants.")}
              <Grid item>
                <FormControl>
                  <Select value={settings.buffer} disabled={alertsDisabled} onChange={ this.props.updateValue} displayEmpty name="settings.buffer" variant="outlined" autoWidth={true}>
                    <MenuItem value="" disabled>Select approximate lead-in and lead-out time as 'time lost' to add to every meeting participation.</MenuItem>
                    {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60].map(i => <MenuItem value={i} key={"buffer-" + i}>{i + " minutes per participant"}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Low 🟢", "If meeting time [(time + buffer) * participants]  estimate exceeds this value, show the estimate with green backdrop.")}
              <Grid item>
                <FormControl>
                  <Select value={settings.alert.low} disabled={alertsDisabled} onChange={ this.props.updateValue} displayEmpty name={"settings.alert.low"} variant="outlined" autoWidth={true}>
                    <MenuItem value="" disabled>Select low estimate treshold.</MenuItem>
                    {tresholds.map(i => <MenuItem value={i * 60} key={"alert-low-" + i}>{i + " hours"}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("Medium 🟠", "If meeting time [(time + buffer) * participants]  estimate exceeds this value, show the estimate with orange backdrop.")}
              <Grid item>
                <FormControl>
                  <Select value={settings.alert.medium} disabled={alertsDisabled} onChange={ this.props.updateValue} displayEmpty name={"settings.alert.medium"} variant="outlined" autoWidth={true}>
                    <MenuItem value="" disabled>Select medium estimate treshold.</MenuItem>
                    {tresholds.map(i => <MenuItem value={i * 60} key={"alert-medium-" + i}>{i + " hours"}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={1} direction="column" >
              { this.props.createHeader("High 🔴", "If meeting time [(time + buffer) * participants]  estimate exceeds this value, show the estimate with red backdrop.")}
              <Grid item>
                <FormControl>
                  <Select value={settings.alert.high} disabled={alertsDisabled} onChange={ this.props.updateValue} displayEmpty name={"settings.alert.high"} variant="outlined" autoWidth={true}>
                    <MenuItem value="" disabled>Select high estimate treshold.</MenuItem>
                    {tresholds.map(i => <MenuItem value={i * 60} key={"alert-high-" + i}>{i + " hours"}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      );
  
  }
  
  render() {
    if (this.props.loading)
      return this.props.loading();
    return this.costAlert();
  }
}

export default AppSettingsCostAlerting;
